export default "__VITE_ASSET__DZKHrsBx__"